import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class MetabaseService {
  constructor(private http: HttpClientService) {}

  public getMetabaseToken(dashboard: string, filters: Record<string, any>): Observable<any> {
    const params = {
      dashboard,
      filters: JSON.stringify(filters),
    };

    return this.http
      .get<any>("/api/metabase/token", { params })
      .pipe(tap(() => console.log("MetabaseService.getMetabaseToken: Ok.")));
  }
}
